import apiClient, { safeJson } from '@/api/client';
import { GroupSettlementResponse } from './types';

export const getGroupSettlement = async ({
    centerId,
    year,
    month,
}: {
    centerId: string;
    year: number;
    month: number;
}) => {
    const res = await apiClient.get(`v1/centers/${centerId}/settlement/group`, {
        searchParams: { year: String(year), month: String(month) },
    });
    const data = await safeJson(res);
    return { status: res.status, data: data as GroupSettlementResponse | null };
};
